import "./styles.css";
import { Box, Container, Grid, Typography, styled } from "@mui/material";
import CreatePasswordBg from "./images/success-icon.svg";
import ResetPasswordBg from "./images/reset.svg";

import { LoadingButton } from "@mui/lab";
import LoginPageCard from "../../../shared/components/auth/loginPageCard";
import MenuContainer from "../../../shared/components/auth/menuContainer";
import LoginRightPanelComponent from "../../../shared/components/auth/loginRightPanel";

const ContentBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  gap: "1rem",
  "& .MuiTypography-h2": {
    fontSize: "32px !important",
    fontWeight: 600,
    color: "313131",
    paddingTop: "24px",
  },
  "& .MuiTypography-body1": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#7B7583",
  },
});

const StyledImage = styled("img")({
  maxWidth: "100%",
  margin: "24px auto",
  display: "flex",
  justifyContent: "center",
});

const ResetSuccess = (props: any) => {
  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "center",
              marginTop: "8.5%",
            }}
          >
            <Grid item md={4}>
              <LoginPageCard padding="8.5%">
                <MenuContainer />
                <ContentBox>
                  <Typography variant="h2">
                    Password Reset Successfully
                  </Typography>
                  <Typography variant="body1">
                    Your password has been successfully reset.{" "}
                  </Typography>
                  <StyledImage
                    src={ResetPasswordBg}
                    className="img-fluid"
                    alt=""
                  />
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    fullWidth
                    size="small"
                    aria-label="Click here to login."
                    href="/admin/login"
                  >
                    Go to login
                  </LoadingButton>
                </ContentBox>
              </LoginPageCard>
            </Grid>
            <Grid item md={4}>
              <LoginRightPanelComponent
                imageSrc={CreatePasswordBg}
                title="Create Password"
                subtitle=""
                titleOpacity={0} // Adjust title opacity
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ResetSuccess;
